import { lazy } from 'react';
import { RouteObject } from 'react-router-dom';

const HomePage = lazy(() => import('../pages/home/page'));
const ServiciosPage = lazy(() => import('../pages/servicios/page'));
const ComoFuncionaPage = lazy(() => import('../pages/como-funciona/page'));
const SobrePage = lazy(() => import('../pages/sobre/page'));
const ContactoPage = lazy(() => import('../pages/contacto/page'));
const PosesionEfectivaPage = lazy(() => import('../pages/posesion-efectiva/page'));
const NotFound = lazy(() => import('../pages/NotFound'));

const routes: RouteObject[] = [
  {
    path: '/',
    element: <HomePage />,
  },
  {
    path: '/servicios',
    element: <ServiciosPage />,
  },
  {
    path: '/como-funciona',
    element: <ComoFuncionaPage />,
  },
  {
    path: '/sobre-nosotros',
    element: <SobrePage />,
  },
  {
    path: '/contacto',
    element: <ContactoPage />,
  },
  {
    path: '/posesion-efectiva',
    element: <PosesionEfectivaPage />,
  },
  {
    path: '*',
    element: <NotFound />,
  },
];

export default routes;
